export default "__VITE_ASSET__BWozW2G3__"